"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const provider_1 = require("@cart/provider");
const widget_trigger_1 = __importDefault(require("@cart/widget-trigger"));
const styled_components_1 = require("styled-components");
const use_media_1 = require("use-media");
const trigger_1 = require("../styles/trigger");
const utils_1 = require("../utils");
const machineTypes_1 = require("../utils/machineTypes");
const Trigger = ({ data, onClick, transparent, store, onMouseEnter, state, send, onRouting }) => {
    var _a, _b;
    const theme = (0, styled_components_1.useTheme)();
    const isMobile = (0, use_media_1.useMedia)({ maxWidth: theme.breakpoint.tablet });
    const { getCartConnected } = (0, provider_1.useCartActions)();
    const expirationDate = ((_a = store === null || store === void 0 ? void 0 : store.data) === null || _a === void 0 ? void 0 : _a.expiration_date) || ((_b = store === null || store === void 0 ? void 0 : store.data) === null || _b === void 0 ? void 0 : _b.expirationDate) || undefined;
    const totalUnits = (0, utils_1.getBadgeAmount)(store);
    const handleExpiration = () => getCartConnected().then((res) => {
        if (res.status === provider_1.ResponseCode.EXPIRED) {
            send(machineTypes_1.MachineTypes.OPEN_ERROR);
        }
        return Promise.resolve(res);
    });
    const isOpen = [machineTypes_1.MachineTypes.OPEN_CART, machineTypes_1.MachineTypes.OPEN_EMPTY].includes(state.value) ||
        (!isMobile && [machineTypes_1.MachineTypes.OPEN_NEW_ITEM, machineTypes_1.MachineTypes.OPEN_NEW_LOYALTY].includes(state.value));
    const isExpired = store.status === provider_1.ResponseCode.EXPIRED;
    const isEmpty = [provider_1.ResponseCode.EMPTY, provider_1.ResponseCode.REOPEN].includes(Number(store.status)) || Object.keys(data !== null && data !== void 0 ? data : {}).length === 0;
    return ((0, jsx_runtime_1.jsx)(trigger_1.WidgetTrigger, { onClick: onClick, onMouseEnter: onMouseEnter, children: (0, jsx_runtime_1.jsx)(widget_trigger_1.default, { expirationDate: expirationDate, totalUnits: totalUnits, onExpiration: handleExpiration, transparent: transparent, open: isOpen, expired: isExpired, empty: isEmpty, onRouting: onRouting }) }));
};
exports.default = Trigger;
